import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls the window to the top on every route change
export const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // If the link has a hash (e.g. #contact), let the browser handle it
        if (!hash) {
            window.scrollTo({ top: 0, behavior: 'instant' });
        }
    }, [pathname, hash]);

    return null;
};
